import { Breadcrumb, Card, Skeleton, Row, Col, notification } from 'antd';
import { ButtonAction, Form, GetValidateFields, Confirm, Button } from 'asumsi-components';
import { LayoutCMS } from 'components';
import React, { useEffect, useState } from 'react';
import useAction from './hooks/useAction';
import postAction from "@pages/post/hooks/useAction";

import { AggregatorSectionComponent, HeroLeftComponent, HeroRightComponent, TopicSectionComponent } from './libraries';

export const PageHomePageFormComponent = (props: any) => {
    // set header page
    const title = 'Home Page'
    const layoutCMSProps = {
        breadcrumb: (
            <>
                <Breadcrumb.Item>
                    {title}
                </Breadcrumb.Item>
            </>
        ),
        documentTitle: title,
        history: props.history,
        pageTitle: title,
    };

    // declare action and attribute needed
    const { isLoader, getData, postData, data, getVideos, videos, uploadBanner } = useAction();
    const { getData: getPostData, data: posts } = postAction();


    // initiate form data
    const initialFieldsValues: any = {
        ads: [],
        feedsTitle: null,
        heroLeft: null,
        heroRight: [],
        topicsTitle: null,
    };

    const [fieldsValues, setFieldsValues]: any = useState(initialFieldsValues);
    const [showConfirmation, setShowConfirm] = useState(false);
    const [paramSubmit, setParamSubmit] = useState({});

    // first load
    useEffect(() => {
        findDataPost();
        findDataVideo();
        if (!data) {
            getData({});
        }
        else {
            setDefault();
        }
    }, [data]);

    const setDefault = async () => {
        if (data) {
            setFieldsValues({
                ads: data.ads,
                feedsTitle: data.feedsTitle,
                heroLeft: data.heroLeft,
                heroRight: data.heroRight,
                topicsTitle: data.topicsTitle,
                errors: []
            });
        }
    }

    //fetch data posts
    const findDataPost = (search?: string) => {
        getPostData({ paga: 1, limit: 20, status: 'published', orderBy: 'updatedAt', sort: 'desc', search });
    }

    //fetch data video
    const findDataVideo = (search?: string) => {
        getVideos({ page: 1, limit: 20, orderBy: 'publishedAt', sort: 'desc', search });
    }

    // handle submit form
    const handleSubmit = (e: any) => {
        const ads: any[] = fieldsValues.ads && fieldsValues.ads.filter((ft: any) => ft.orderNumber > 0);
        const newVal: any = { ...fieldsValues, ads };
        const validateFields = GetValidateFields(newVal);
        const { err, values } = validateFields;
        e.preventDefault();
        if (!err) {
            setParamSubmit(values);
            setShowConfirm(true);
        }
    };

    const onPreview = async (file: any) => {
        let src = file.url;
        if (!src) {
            src = await new Promise(resolve => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
            });
        }
        const image = new Image();
        image.src = src;
        const imgWindow = window.open(src);
        if (imgWindow) {
            imgWindow.document.write(image.outerHTML);
        }
    };

    const beforeUpload = (file: any) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            notification.error({
                description: "You can only upload JPG/PNG file",
                duration: 5,
                message: 'Failed',
            });
            //   message.error('You can only upload JPG/PNG file!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            notification.error({
                description: "Image must smaller than 2MB!",
                duration: 5,
                message: 'Failed',
            });
            //   message.error('Image must smaller than 2MB!');
        }
        return isJpgOrPng && isLt2M;
    }

    const getBase64 = (file: any) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    // return JSX Element 
    return (
        <LayoutCMS {...layoutCMSProps}>
            <Card className="asumsi-card-form-shadow-rd-15">
                <Form titleBold={true}>
                    <Skeleton loading={isLoader}>
                        <Row gutter={30}>
                            <Col lg={{ span: 24 }} md={{ span: 24 }} xs={{ span: 32 }}>
                                <Card className="m-b-20 hero-card" style={{ paddingLeft: "20px", paddingRight: "20px" }}>
                                    <div className="title-desc">
                                        <div className="title">HERO SECTION</div>
                                    </div>
                                    <Row>
                                        <HeroLeftComponent {...props} findDataVideo={findDataVideo}  findDataPost={findDataPost} setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} posts={posts} videos={videos} />
                                        <HeroRightComponent {...props} findDataVideo={findDataVideo} findDataPost={findDataPost} setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} posts={posts} videos={videos} uploadBanner={uploadBanner} getBase64={getBase64} onPreview={onPreview}
                                            beforeUpload={beforeUpload} />
                                    </Row>
                                </Card>
                                <TopicSectionComponent {...props} setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} />
                                <AggregatorSectionComponent {...props} setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} uploadBanner={uploadBanner} getBase64={getBase64} onPreview={onPreview}
                                    beforeUpload={beforeUpload} />
                            </Col>
                        </Row>
                    </Skeleton>
                    <ButtonAction
                        right={
                            <Button type="green" size="medium" disabled={fieldsValues.errors && fieldsValues.errors.length > 0} loading={isLoader} onClick={handleSubmit}>
                                Save
                            </Button>
                        }
                    />
                </Form>
            </Card>
            <Confirm
                key="confirm-save"
                show={showConfirmation}
                setShow={setShowConfirm}
                onOk={async () => {
                    // do post data
                    postData(paramSubmit);
                }}
                content='Apakah Anda yakin untuk menyimpan data ini?'
                title='Konfirmasi'
                okText='Ya'
                cancelText='Tidak'
            />
        </LayoutCMS >
    );
};

export default PageHomePageFormComponent;



// WEBPACK FOOTER //
// ./src/pages/homepage-form/component.tsx